<template>
  <yxtf-dialog
    append-to-body
    :visible.sync="show"
    width="520px"
    custom-class="text-center yxtbiz-gratuity"
    @close="close"
    @closed="closed"
  >
    <!-- 初始化中 -->
    <i
      v-if="initing"
      v-floading="initing"
      class="yxtbiz-ds-initing pa z-19 right-top over-hidden"
    ></i>
    <!-- 错误页 -->
    <div
      v-if="requestErrorText"
      class="yxtbiz-ds-empty"
    >
      <yxtf-empty
        size="small"
        permission
        :empty-text="requestErrorText"
      />
    </div>
    <template v-else>
      <!-- 头像 -->
      <yxtf-portrait
        size="88px"
        :img-url="imgUrl"
        :username="targetUserInfo.fullname"
        class="mt16"
      />
      <!-- 打赏XX -->
      <yxt-tooltip
        v-if="anonymous === 0"
        placement="top"
        :open-filter="true"
        popper-class="yxtbiz-ds-dept"
        effect="light"
      >
        <div slot="content">
          <yxtbiz-user-name :name="targetFullName" />
          <template v-if="targetUserInfo.deptName">-<yxtbiz-dept-name :name="targetUserInfo.deptName" /></template>
        </div>
        <div class="yxtbiz-ds-name font-size-16 nowrap ellipsis">
          {{ $t('pc_biz_lbl_gratuity') }}<yxtbiz-user-name :name="targetFullName" />
          <template v-if="targetUserInfo.deptName">-<yxtbiz-dept-name :name="targetUserInfo.deptName" /></template>
        </div>
      </yxt-tooltip>
      <!-- 点赞是美意，打赏是鼓励~ -->
      <div class="yxtbiz-ds-tip mt8 text-8c">{{ $t('pc_biz_lbl_gratuitytip') }}</div>
      <!-- 选项列表 -->
      <div
        class="yxtbiz-ds-options"
        :class="{'text-left': options.length > 2}"
      >
        <!-- 只有一个选项 -->
        <div
          v-if="onlyOne.btn"
          class="yxtbiz-ds-only-btn pt24 lh40 text-26"
        >{{ options[0].pointValue }}{{ $t('pc_biz_enroll_lbl_integral') }}<!-- 积分 --></div>
        <template v-else>
          <span
            v-for="(item, index) of options"
            :key="item.id"
            class="yxtbiz-ds-option d-in-block v-top"
            :class="{'yxtbiz-ds-selected color-primary-6': item.select, 'yxtbiz-ds-only-input': onlyOne.input, 'pb24': index === options.length - 1 && item.switchType !== 1}"
          >
            <!-- 选项 -->
            <yxtf-button
              v-if="item.switchType !== 1"
              plain
              :disabled="item.disabled"
              @click="selectOptionHandle(index)"
            >
              <span
                class="mr4 font-size-18 v-mid text-26 font-bolder"
                :class="{'text-26': !item.select}"
              >{{ item.pointValue }}</span>
              <span class="font-size-12 v-mid">{{ $t('pc_biz_enroll_lbl_integral') }}<!-- 积分 --></span>
            </yxtf-button>
            <!-- input -->
            <span
              v-else
              class="yxtbiz-ds-input pb24 d-in-block pr"
            >
              <!-- 自定义积分 -->
              <yxtf-input
                v-model="inputScore"
                ref="input"
                :disabled="item.disabled"
                :placeholder="$t('pc_biz_lbl_custompoint')"
                :class="inputScore ? 'font-size-18' : 'font-size-12'"
                @focus="inputHandle('focus')"
                @blur="inputHandle('blur')"
              />
              <label
                v-if="inputMsg"
                class="pa z-19 font-size-12 text-8c custom-label--nowrap"
                :class="inputLabelPosition"
              >{{ inputMsg }}</label>
            </span>
          </span>
        </template>
      </div>
      <div class="yxtbiz-ds-sure-btn pr">
        <!-- 您的积分不足无法打赏~ -->
        <div
          v-if="!preview && showError"
          class="pa z-19 width-percent-100 lh20 font-size-12 yxtf-color-danger"
        >{{ $t('pc_biz_lbl_pointinsufficient') }}</div>
        <!-- 打赏按钮 -->
        <yxtf-button
          type="primary"
          size="others"
          :loading="submiting"
          :disabled="btnDisabled"
          @click="sureHandle"
        >
          {{ $t('pc_biz_lbl_gratuity') }}
        </yxtf-button>
      </div>
      <div class="mv8 font-size-12 text-8c">
        <!-- 可用积分 -->
        <span>{{ $t('pc_biz_lbl_enablepoint') }}：{{ totalMallPoint.toLocaleString() }}</span>
        <!-- 打赏剩余次数 - 只有打开限制才显示 -->
        <span
          v-if="limitSwitch === 1"
          class="ml20"
        >{{ cycleText }}{{ $t('pc_biz_lbl_remaintime') }}：{{ surplusRewardTimes }}{{ $t('pc_biz_ote_lbl_time') }}<!-- 次 --></span>
      </div>
    </template>
  </yxtf-dialog>
</template>

<script>
// import { yxtOpenData } from 'yxt-biz-pc-base';
import { isOpenPlatform } from 'yxt-open-data/es';
import { getGratuityBaseInfo, postGratuity } from './service';
// const _isOpenPlatform = yxtOpenData ? yxtOpenData.isOpenPlatform() : false; // 钉钉、企微
const _isOpenPlatform = isOpenPlatform(); // 钉钉、企微

export default {
  name: 'YxtbizGratuity',
  props: {
    visible: Boolean,
    preview: Boolean, // 预览
    anonymous: { type: [String, Number], default: 0 }, // 是否匿名 0否 1是
    moduleCode: { type: String, required: true }, // 打赏模块编号 - boss 中获取
    serviceId: { type: String, required: true }, // 业务id - 比如文章 id、知识 id
    serviceName: { type: String, required: true }, // 业务名称 - 比如文章名称、知识名称
    sourceId: { type: String }, // 来源Id
    sourceType: { type: String, required: true }, // 来源(来源code) - https://yunxuetang.feishu.cn/sheets/shtcnSy9DP8rSLoJX5NqOlry2Pg‘
    moduleType: { type: String, required: true }, // 模块(功能模块code) - https://yunxuetang.feishu.cn/sheets/shtcnSy9DP8rSLoJX5NqOlry2Pg
    targetUserId: { type: String, required: true }, // 被打赏用户Id
    targetOrgId: { type: String, default: '' }, // 被打赏用户机构Id【集团版必传】
    reward: Function // 自定义打赏钩子
  },
  data() {
    this.anonymousName = this.$t('pc_biz_lbl_anonymousname'/** 匿名用户 */);
    return {
      show: false,
      initing: false, // 初始化中
      submiting: false, // 提交中
      limitSwitch: 0, // 打赏开关 0 关 1 开
      cycleText: '', // 0-每天 1-每月 2-当年
      totalMallPoint: 0, // 可用积分
      surplusRewardTimes: 0, // 剩余打赏次数
      inputScore: undefined, // 输入的积分
      options: [], // 选项列表
      showError: false, // 显示错误信息
      requestErrorText: null, // 请求详情错误信息
      inputMsg: false, // 输入框底下信息是否显示
      targetUserInfo: {} // 被打赏人信息
    };
  },
  computed: {
    imgUrl() {
      return this.anonymous ? `${this.$staticBaseUrl}assets/6821919d/7a5ff22f/anonymous-header.svg` : this.targetUserInfo.imgUrl;
    },
    targetFullName() {
      return this.anonymous ? this.anonymousName : this.targetUserInfo.fullname;
    },
    // 选择的选项
    selectedOption() {
      return this.options.find(item => item.select && item.switchType === 0);
    },
    // 提交按钮是否禁用
    btnDisabled() {
      if (this.showError) return true;
      let input = this.findOption(1);
      let inputScore = window.parseInt(this.inputScore || 0);
      // 没有选择选项、没有输入内容
      return !(this.selectedOption || (input && inputScore && inputScore <= this.maxInputValue));
      // (input && inputScore && inputScore <= input.pointValue && inputScore <= this.totalMallPoint))
    },
    // 输入框下面文字对齐方式
    inputLabelPosition() {
      let btnLen = this.findOption(0).length;
      if (btnLen % 3 === 2) return 'right';
      if (btnLen !== 0) return 'left';
      return 'center';
    },
    // 只有一个选项或输入框
    onlyOne() {
      let oneOption = this.options.length === 1; // 选项列表中只有一个
      let onlyInput = oneOption && this.options[0].switchType === 1; // 只有一个输入框
      return {
        btn: oneOption && !onlyInput, // 只有一个选项
        input: onlyInput // 只有一个输入框
      };
    },
    // 输入框最大值
    maxInputValue() {
      // 输入框限制输入值
      let pointValue = (this.findOption(1) || {}).pointValue;
      return pointValue > this.totalMallPoint ? this.totalMallPoint : pointValue;
    },
    // 打赏的分值
    gratuityPoint() {
      return this.inputScore || (this.selectedOption || {}).pointValue;
    }
  },
  watch: {
    // 输入框内容改变
    inputScore(val) {
      if (val) {
        val = val.replace(/[^\d]/g, '').replace(/^[0]+/, '');
        this.inputScore = val.length > 6 ? val.substring(0, 6) : val;
      }
    },
    visible(val) {
      this.show = val;
      if (this.checkIsSelf()) return;
      val && this.requestConfig();
    }
  },
  methods: {
    // 初始化弹框
    init(data = {}) {
      if (data.error) { // 直接报错
        this.requestErrorText = data.error;
      } else if (this.preview) { // 预览
        this.totalMallPoint = data.totalPoint || 0;
        if (data.rewardTimes) {
          this.limitSwitch = 1;
          this.cycleText = this.getCycleText(data.cycleType);
          this.surplusRewardTimes = data.rewardTimes;
        }
        this.setOptions(data.list);
      } else {
        // 不是自己
        if (!this.checkIsSelf()) {
          this.requestConfig();
        }
      }
      this.show = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    // cycleType 0-每天 1-每月 2-当年
    getCycleText(cycleType) {
      return [
        this.$t('biz_lbl_currday'/** 今日 */),
        this.$t('biz_lbl_currmonth'/** 本月 */),
        this.$t('biz_lbl_curryear'/** 本年 */)
      ][cycleType] || '';
    },
    // 请求配置
    requestConfig() {
      this.initing = true;
      getGratuityBaseInfo({
        anonymous: this.anonymous,
        moduleCode: this.moduleCode,
        serviceId: this.serviceId,
        sourceType: this.sourceType,
        targetUserId: this.targetUserId, // 用来判断打赏人、被打赏人
        targetOrgId: this.targetOrgId // 被打赏人机构ID
      }).then(res => {
        this.limitSwitch = res.limitSwitch; // 限制打赏次数开关
        if (res.limitSwitch) {
          // 剩余打赏次数 = 限制打赏次数 - 已打赏次数
          this.surplusRewardTimes = res.rewardTimes - res.userRewardTimes;
        }
        this.cycleText = this.getCycleText(res.cycleType);
        this.totalMallPoint = res.totalMallPoint || 0; // 可用积分
        // 被打赏人信息
        this.targetUserInfo = res.udpLiteUserBean || {};
        this.setOptions(res.rewardSet4Gets);
      }).catch(e => {
        let message;
        try {
          message = e.error.message;
        } catch (error) {
          message = this.$t('common_msg_unknowError');
        }
        if (e.status === 401) {
          message = this.$t('biz_lbl_token_expired'/** token 失效 */);
        }
        this.requestErrorText = message;
      }).then(() => {
        this.initing = false;
        this.$nextTick(() => {
          // 只有一个输入框, 获得焦点
          if (this.onlyOne.input && this.totalMallPoint > 0) {
            let inputRef = this.$refs.input[0];
            inputRef && inputRef.focus();
          }
        });
      });
    },
    // 提交
    sureHandle() {
      if (this.preview) return;
      this.submiting = true;
      let serviceName = '-【' + this.serviceName + '】';
      const postData = {
        moduleCode: this.moduleCode,
        moduleType: this.moduleType,
        point: this.gratuityPoint,
        serviceId: this.serviceId,
        sourceId: this.sourceId || this.serviceId,
        sourceType: this.sourceType,
        targetUserId: this.targetUserId,
        targetOrgId: this.targetOrgId || this.targetUserInfo.orgId,
        // 支持ssp能存储的最大remark字符数500，做截取
        remark: this.serviceName.slice(0, 500),
        myRemark: (this.$t('pc_biz_lbl_gratuity') +
          (this.anonymous ? this.anonymousName : _isOpenPlatform ? this.targetUserInfo.username : this.targetUserInfo.fullname) +
          serviceName).slice(0, 500), // 打赏者说明
        toRemark: (this.$t('pc_biz_lbl_gratuityby', [_isOpenPlatform ? window.localStorage.username : window.localStorage.fullname]) +
          serviceName).slice(0, 500) // 被打赏者说明
      };
      if (this.reward) {
        // 自定义打赏，返回打赏请求参数
        this.reward(postData);
        return;
      }
      postGratuity(postData).then(() => {
        this.$message.success(this.$t('pc_biz_lbl_gratuitysuccess'/** 打赏成功，谢谢您的鼓励 */));
        this.resolve && this.resolve(this.gratuityPoint);
        this.show = false;
      }).catch(e => {
        this.$message.error(e.error.message);
        this.submiting = false;
        /**
         * 2021051-打赏已达上限
         * 2021053-不允许重复打赏，已经打赏过了
         */
        if ([2021051, 2021053].includes(e.code)) {
          this.show = false;
        } else if (e.code === 2021054) {
          // 积分不足,重新请求配置
          this.requestConfig();
        }
      });
    },
    // 设置选项
    setOptions(options) {
      let totalMallPoint = this.totalMallPoint;
      let input = this.findOption(1, options); // 输入框
      let btns = this.findOption(0, options); // 选项列表
      // 排序
      btns.sort((a, b) => {
        if (a.pointValue >= b.pointValue) return 1;
        return -1;
      }).forEach(item => {
        item.select = false; // 选项选择状态
        item.disabled = item.pointValue > totalMallPoint; // 选项禁用状态
      });
      let noPoint = totalMallPoint <= 0;
      let showError = noPoint;
      // 有输入框
      if (input) {
        input.disabled = noPoint; // 输入框禁用状态
        btns.push(input); // 加入列表
      } else { // 只有选项
        // 可用积分小于最小积分
        showError = btns[0].pointValue > totalMallPoint;
      }
      // 有选项, 并且第一个选项可选
      if (btns.length && !btns[0].disabled) {
        btns[0].select = true;
      }
      // 显示错误信息（没有积分、只有选项并且积分不足）
      this.showError = showError;
      this.options = btns;
    },
    // 查找选项, type: 0-选项 1-输入框
    findOption(type, options) {
      options = options || this.options;
      // 输入框
      if (type === 1) {
        return options.find(o => o.switchType === type);
      }
      // 选项
      return options.filter(item => item.switchType === type);
    },
    // 选择分数
    selectOptionHandle(index) {
      let isNumber = typeof index === 'number';
      this.options.forEach((item, i) => {
        item.select = isNumber && index === i;
      });
      // 有输入框
      if (this.findOption(1) && isNumber) {
        this.inputScore = undefined; // 清空输入框内容
        this.inputMsg = ''; // 清除输入框提示
      }
    },
    // 输入框获得、失去焦点 'focus' 'blur'
    inputHandle(type) {
      let isFocus = type === 'focus';
      // 有值，取消选择选项
      isFocus && this.selectOptionHandle();
      if (isFocus || (this.maxInputValue && this.inputScore > this.maxInputValue)) {
        this.inputMsg = this.$t('pc_biz_lbl_inputmaxpoint', [this.maxInputValue]/** 最多可打赏XX积分 */);
        return;
      }
      // 失去焦点时，没有输入积分，并且没有选中选项
      if (!this.inputScore && !this.selectedOption) {
        this.inputMsg = this.$t('pc_biz_lbl_inputpoint'/** 请输入打赏积分 */);
      } else {
        this.inputMsg = '';
      }
    },
    // 检查是不是同一个人
    checkIsSelf() {
      let isSelf = this.targetUserId === window.localStorage.userId && (!this.targetOrgId || (this.targetOrgId && this.targetOrgId === window.localStorage.orgId));
      isSelf && (this.requestErrorText = this.$t('pc_biz_lbl_nosupportgratuityself'/** 系统不支持打赏自己 */));
      return isSelf;
    },
    close() {
      this.$emit('close', this.gratuityPoint);
      this.resolve = null;
      this.submiting = false;
      this.inputScore = undefined;
      this.show = false;
      this.$emit('update:visible', false);
    },
    closed() {
      this.requestErrorText = null;
    },
    reset() {
      this.submiting = false;
      this.inputScore = undefined;
      this.requestConfig();
    }
  }
};
</script>

<style lang="scss">
.yxtbiz-gratuity {
  .custom-label--nowrap {
    white-space: nowrap;
    word-break: normal;
    word-wrap: normal;
  }
}
</style>
